import { RiskLevel } from '@prisma/client';
import { cn } from '~/lib/utils';

type Props = {
  riskLevel: RiskLevel | null;
  isFullLabel?: boolean;
  isDropdown?: boolean;
};

const RISK_COLOR = {
  [RiskLevel.LOW]: '#69D100',
  [RiskLevel.MEDIUM]: '#F59300',
  [RiskLevel.HIGH]: '#FF3737',
} as const;

const RISK_LABEL = {
  [RiskLevel.LOW]: 'Low',
  [RiskLevel.MEDIUM]: 'Medium',
  [RiskLevel.HIGH]: 'High',
} as const;

const FILLED_BARS = {
  [RiskLevel.LOW]: 1,
  [RiskLevel.MEDIUM]: 2,
  [RiskLevel.HIGH]: 3,
} as const;

const BARS = [
  { x: 1.5, y: 9, h: 5 },
  { x: 6.5, y: 5.5, h: 8.5 },
  { x: 11.5, y: 2, h: 12 },
] as const;

function RiskBars({ filled, color }: { filled: 1 | 2 | 3; color: string }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      className={cn('size-3.5 shrink-0', color !== 'currentColor' && 'text-muted-foreground/35')}
    >
      {BARS.map((bar, i) => (
        <rect
          key={bar.x}
          x={bar.x}
          y={bar.y}
          width="3"
          height={bar.h}
          rx="1"
          fill={i < filled ? color : 'currentColor'}
          opacity={color === 'currentColor' && i >= filled ? 0.35 : 1}
        />
      ))}
    </svg>
  );
}

export function RiskLevelIcon({
  riskLevel,
  color,
}: {
  riskLevel: Exclude<RiskLevel, typeof RiskLevel.AUTO>;
  color?: string;
}) {
  return <RiskBars filled={FILLED_BARS[riskLevel]} color={color ?? RISK_COLOR[riskLevel]} />;
}

export default function RiskLevelComponent({ riskLevel, isFullLabel }: Props) {
  if (!riskLevel || riskLevel === RiskLevel.AUTO) return null;

  return (
    <span className={cn('inline-flex items-center', isFullLabel && 'gap-2')}>
      <RiskLevelIcon riskLevel={riskLevel} />
      {isFullLabel ? <span>{RISK_LABEL[riskLevel]}</span> : null}
    </span>
  );
}
